import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'modules/state-mgmt/store';
import { setWorkerPIIPinInformation } from 'modules/state-mgmt/onboarding';
import { useTimer } from './useTimer';

const usePiiVisibility = () => {
  const dispatch = useAppDispatch();
  const workerPIIPinInformation = useAppSelector(state => state.onboarding?.workerPIIPinInformation);

  const { isRunning, restart, pause } = useTimer({
    expiryTimestamp: new Date(),
    autoStart: false,
    onExpire: () =>
      dispatch(
        setWorkerPIIPinInformation({
          piiFieldVisibilityExpiredAt: null,
          isPIIVisible: false,
        }),
      ),
  });

  useEffect(() => {
    if (
      workerPIIPinInformation?.isPIIVisible &&
      workerPIIPinInformation?.piiFieldVisibilityExpiredAt &&
      new Date(workerPIIPinInformation?.piiFieldVisibilityExpiredAt).getTime() > new Date().getTime()
    ) {
      restart(new Date(workerPIIPinInformation?.piiFieldVisibilityExpiredAt));
    } else {
      if (isRunning) {
        pause();
      }
    }
  }, [workerPIIPinInformation?.isPIIVisible, workerPIIPinInformation?.piiFieldVisibilityExpiredAt]);
};

export default usePiiVisibility;
